<template>
    <component :is="elementLayout" ref="container">
        <template #element>
            <!-- Sorting container -->
            <div :class="classes.list" role="list" :aria-labelledby="labelId" ref="list">
                <div v-for="(val, i) in value" :key="i" :class="classes.listItem" role="listitem" :data-id="`${path}-${i}`">
                    <slot :index="i">
                        <component
                            :is="component(prototype)"
                            v-if="prototype.type"
                            v-bind="getProtoType(prototype, i)"
                            :name="i"
                            :key="i"
                        />
                    </slot>

                    <!-- Sort handle -->
                    <span
                        v-if="hasSort"
                        :class="classes.handle"
                        data-handle
                    >
                        <span :class="classes.handleIcon"></span>
                    </span>

                    <!-- Remove button -->
                    <div
                        v-if="hasRemove(i)"
                        :aria-roledescription="form$.translations.vueform.a11y.list.remove"
                        :class="classes.remove"
                        :id="`${path}-${i}-remove-button`"
                        @click.prevent="handleRemove(i)"
                        @keypress.space.enter="handleRemove(i)"
                        role="button"
                        tabindex="0"
                    >
                        <span :class="classes.removeIcon"></span>
                    </div>
                </div>
            </div>

            <!-- Add button -->
            <div
                v-if="hasAdd"
                :class="classes.add"
                :id="`${fieldId}-add-button`"
                @click.prevent="handleAdd"
                @keypress.enter.space="handleAdd"
                v-html="addLabel"
                role="button"
                tabindex="0"
            />

            <!-- Bulk member upload (CSV / Excel) — collapsed behind a toggle button -->
            <div v-if="bulkUploadEnabled" class="vf-repeater-bulk uk-margin-small-top">
                <a
                    href="#"
                    class="uk-button uk-button-default uk-button-small"
                    @click.prevent="toggleBulkUpload"
                    :aria-expanded="bulkExpanded ? 'true' : 'false'"
                >
                    <span uk-icon="icon: upload; ratio: 0.85" class="uk-margin-small-right"></span>{{ bulkUpload.toggle }}
                    <span v-show="!bulkExpanded" uk-icon="icon: chevron-down; ratio: 0.85" class="uk-margin-small-left"></span>
                    <span v-show="bulkExpanded" uk-icon="icon: chevron-up; ratio: 0.85" class="uk-margin-small-left"></span>
                </a>
                <div v-show="bulkExpanded" class="uk-margin-small-top">
                    <p class="uk-text-meta uk-margin-remove-bottom">{{ bulkUpload.hint }}</p>
                    <div class="uk-margin-small-top">
                        <label class="uk-button uk-button-default uk-button-small uk-margin-small-right" role="button" tabindex="0">
                            <span uk-icon="icon: upload; ratio: 0.85" class="uk-margin-small-right"></span>{{ bulkUpload.button }}
                            <input type="file" accept=".csv,.txt,.xlsx,.xls" @change="handleBulkImport" hidden>
                        </label>
                        <a href="#" class="uk-button uk-button-text" @click.prevent="handleTemplateDownload">
                            <span uk-icon="icon: download; ratio: 0.85" class="uk-margin-small-right"></span>{{ bulkUpload.template }}
                        </a>
                        <!-- Phone-format guidance tucked behind an info tooltip (hover/focus) -->
                        <a
                            v-if="bulkHasPhoneField"
                            href="#"
                            class="uk-text-muted uk-margin-small-left"
                            :title="bulkUpload.phone_hint"
                            :aria-label="bulkUpload.phone_hint"
                            uk-tooltip="pos: top-left"
                            @click.prevent
                        ><span uk-icon="icon: receiver; ratio: 0.9"></span></a>
                    </div>
                    <div v-if="bulkImportMessages.length" class="vf-repeater-bulk-messages uk-margin-small-top">
                        <div
                            v-for="(msg, mi) in bulkImportMessages"
                            :key="mi"
                            :class="['uk-alert', 'uk-margin-remove-top', 'uk-margin-small-bottom', bulkMessageClass(msg.level)]"
                        >
                            <p class="uk-margin-remove">{{ msg.text }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- Default element slots -->
        <template v-for="(component, slot) in elementSlots" #[slot]><slot :name="slot" :el$="el$"><component :is="component" :el$="el$"/></slot></template>
    </component>
</template>

<script>
export default {
    name: 'ListElement',
    data() {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                list: '',
                listItem: '',
                handle: '',
                handleIcon: '',
                remove: '',
                removeIcon: '',
                add: '',
            },
        }
    },
}
</script>

<style lang="scss">
</style>
